import React from "react";
import { cn } from "@/lib/utils";

export const StatCard = ({ label, value, icon: Icon, accent = "#00F0FF", className = "" }) => (
  <div className={cn("glass rounded-2xl p-5", className)} data-testid={`stat-${String(label).toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="flex items-center justify-between">
      <span className="label-accent text-slate-400">{label}</span>
      {Icon && (
        <span className="flex h-8 w-8 items-center justify-center rounded-lg" style={{ background: `${accent}1a` }}>
          <Icon className="h-4 w-4" style={{ color: accent }} />
        </span>
      )}
    </div>
    <div className="mt-2 font-heading text-2xl font-extrabold text-white">{value}</div>
  </div>
);

export default StatCard;
